/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierMapping
 */
export interface SupplierMapping {
    /**
     * 
     * @type {string}
     * @memberof SupplierMapping
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierMapping
     */
    supplierPropertyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierMapping
     */
    mapped?: boolean;
}

/**
 * Check if a given object implements the SupplierMapping interface.
 */
export function instanceOfSupplierMapping(value: object): value is SupplierMapping {
    return true;
}

export function SupplierMappingFromJSON(json: any): SupplierMapping {
    return SupplierMappingFromJSONTyped(json, false);
}

export function SupplierMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'supplierPropertyId': json['supplier_property_id'] == null ? undefined : json['supplier_property_id'],
        'mapped': json['mapped'] == null ? undefined : json['mapped'],
    };
}

export function SupplierMappingToJSON(json: any): SupplierMapping {
    return SupplierMappingToJSONTyped(json, false);
}

export function SupplierMappingToJSONTyped(value?: SupplierMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supplier': value['supplier'],
        'supplier_property_id': value['supplierPropertyId'],
        'mapped': value['mapped'],
    };
}

